import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { asyncConnect } from 'redux-connect';
import { browserHistory } from 'react-router';

import ApplyCSS from '../../../../components/ApplyCSS';

import AddAddressForm from './components/AddAddressForm';
import HeaderFormRegister from './components/HeaderFormRegister';
import BottomFormRegister from './components/FooterFormRegister';

// Actions
import * as createAccountActions from '../../../Accounts/createAccount/actions';
import * as labelsActions from '../../../../components/labels/actions';
import * as getGlobleObject from './../../../../components/globleObject/reducer';

import commonUtil from '../../../../utils/commonUtil';
import * as GiftRegistryNewAddressAction from './actions';
import { updateDeliveryAddress } from './actions';
import { getDeliveryAddressInfo, addEventDeliveryAddress, updateEventManagementAddresses } from '../../../eventManagement/page/EventData/DeliveryAddress/actions';
import AppEvents from '../../../App/AppEvents';
import { createTagsForInvalidFormControls } from '../../../../utils/googleTagManagerUtils';
import { addressStateValidation, andStreetValidation, betweenStreetValidation, buildingValidation, cityValidation, colonyValidation, focusValidation, formDataValidation, insideNumberValidation,
mobileValidation, municipaltyValidation, nickNameValidation, outherNumberValidation, postalCodeValidation, privatePhoneTotalValidation, streetValidation } from './components/validationField';
import { colonySetOptions, municipalitySetOptions, stateSetOptions } from './components/selectorsLogic';
import {
  addAddressFailedCreateTag,
  addAddressSuccessCreateTag,
  getAddressFailedCreateTag } from './components/tagManager';

const { isLablesLoaded, loadLables } = labelsActions;
const { saveUserAddressDetail, addUserAddressDetail } = GiftRegistryNewAddressAction;
const applicationRoutes = commonUtil.getApplicationRoutes();

const pageName = 'registerGiftDelivery';
const channel = commonUtil.getChannel();
const constChannel = commonUtil.getClientConstForChannel();

const textIdElements = {
  street: 'street',
  outerNumber: 'outerNumber',
  insideNumber: 'insideNumber',
  building: 'building',
  betweenStreet: 'betweenStreet',
  andStreet: 'andStreet',
  privatePhone: 'privatePhone',
  mobile: 'mobile',
};

@asyncConnect([{
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  labels: store.labels.data,
  error: store.labels.error,
  user: store.user.data,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  addressSearchLoading: store.giftRegistryNewAddress.loading,
  giftRegistryNewAddress: store.giftRegistryNewAddress.data,
  createEventObject: store.createEventObject,
  stateList: store.createEvent.dataState,
  giftRegistryAddress: store.giftRegistryAddress,
  globleObj: store.globleObject,
  addressSearchLoaded: store.giftRegistryNewAddress.addressSearchLoading,
  deliveryAddress: store.deliveryAddress.data,
  eventManagementAddresses: store.deliveryAddress.eventManagementAddresses,
}),
  { ...labelsActions, ...getGlobleObject, ...GiftRegistryNewAddressAction, ...createAccountActions })

class GiftRegistryNewAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOtherColony: false,
      selectorStateRefValue: '',
      selectorMunicipaltyRefValue: '',
      selectorColonyRefValue: '',
      emptyPostalCodeValid: false,
      celebrityName: '',
      deliveryAddressNickNames: props?.location?.state?.deliveryAddressNickNames || [],
    };

    this.showOtherColony = false;
    this.editAddress = false;
    this.fromEventDataCreated = {};
    this.setStateOption = [];
    this.setMunicipalityOption = [];
    this.setColonyOption = [];

    const createEventObject = props.createEventObject || {};
    const SelectTypeCelebration = createEventObject.SelectTypeCelebration || {};
    const config = SelectTypeCelebration.selectedEventConfiguration || {};
    const location = props.location || {};
    const query = location.query || {};

    this.locationQuery = query || {};
    // * this value is retrive in this.locationQuery.currentStep but here is static;
    this.step = 2;

    this.validationFlag = false;
    this.requestFromDeliveryAddressData = {};
    this.lastPincode = '';
    this.userData = {};
    this.currentEventUrl = config.url || null;

    this.user = props.user || {};
    this.configName = config.name || null;
    this.currentUserData = this.user.result || {};

    const configNameData = createEventObject[this.configName + '_1'] || [];
    const configNameDataMotherName = configNameData.data || [];
    this.currentUserMotherName = configNameDataMotherName[0] && configNameDataMotherName[0].motherName;
  }

  componentWillMount = () => {
    if (typeof window !== 'undefined') {
      window.addEventListener('beforeunload', commonUtil.browserRefresh);
    }
    if (this.props.createEventObject.SelectTypeCelebration === undefined && browserHistory) {
      // TODO: Validate redirection when reload page of this component, specifically when an event has already been created, for now redirect to home
      // browserHistory.push(applicationRoutes.mesaType);
    }
    if (channel === constChannel.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('beforeunload', commonUtil.browserRefresh);
    }
    if (channel === constChannel.WAP) {
      AppEvents.unsubscribe(this.wapBackButtonEvent);
    }
  }

  componentDidMount() {
    AppEvents.publish(this.wapBackButtonEvent, [this.redirectToPrevPage]);
  }

  setCelebrityName = () => {
    const { getCurrentLocation = () => {} } = browserHistory;
    const { state = {} } = getCurrentLocation();
    this.fromEventDataCreated = { ...state };
    return state;
  }

  componentWillReceiveProps(newProps) {
    if (newProps.giftRegistryNewAddress && newProps.giftRegistryNewAddress &&
      newProps.giftRegistryNewAddress.addrSearchResponse && !newProps.loading) {
      this.setState({
        ...this.state,
        showOtherColony: false,
      });
    }
  }

  setRef = (ref) => {
    if (!ref) return;

    const refElements = {
      nickName: () => this.setState({ ...this.state, nickNameRefValue: ref }),
      postalCode: () => this.setState({ ...this.state, postalCodeRefValue: ref }),
      otherColony: () => this.setState({ ...this.state, otherColonyRefValue: ref }),
      city: () => this.setState({ ...this.state, cityRefValue: ref }),
      street: () => this.setState({ ...this.state, streetRefValue: ref }),
      outerNumber: () => this.setState({ ...this.state, outherNumberRefValue: ref }),
      insideNumber: () => this.setState({ ...this.state, insideNumberRefValue: ref }),
      building: () => this.setState({ ...this.state, buildingRefValue: ref }),
      betweenStreet: () => this.setState({ ...this.state, betweenStreetRefValue: ref }),
      andStreet: () => this.setState({ ...this.state, andStreetRefValue: ref }),
      mobile: () => this.setState({ ...this.state, mobileRefValue: ref }),
      privatePhone: () => this.setState({ ...this.state, privatePhoneRefValue: ref }),
    };

    refElements[ref.props.htmlId]();
  };

  setRefWarning = (ref) => {
    if (!ref) return;

    this.setState({ ...this.state, warningRefValue: ref });
  }

  redirectToEventManagement = () =>{
    const { state = {} } = this.props.location || {};
    const { eventId } = state;
     browserHistory.push({
          pathname: commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: eventId }),
          state: {
            activeSection: 'direcciones-de-entrega',
          },
        })
        return true;
  }

  redirectToPrevPage = () => {
    const { state = {} } = this.props.location || {};
    const {isEventManagement, eventId } = state;
    if(isEventManagement){
        //onclick cancler button returect to adrres section
        browserHistory.push({
          pathname: commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: eventId }),
          state: {
            activeSection: 'direcciones-de-entrega',
          },
        })
        return true;
    }
    const { _fetchProfileEventsInfo } = this.props;
    _fetchProfileEventsInfo().then((response) => {
      if (response.status.status === 'success') {
        // * Redirect to prev page when cancel process in address form
        // * In aditional address form DATOS DE EVENTO
        const existOtherAddress = this.currentEventUrl
          ? this.currentEventUrl + '?address=true'
          : browserHistory.goBack();

        browserHistory.push(existOtherAddress);
      } else if (response.status.status === 'failure') {
        // TODO: REVIEW CASE  ``DATOS EVENTO``
        browserHistory.push(applicationRoutes.createAccount);
      }
    });

    const { flushAddressSearch } = this.props; // eslint-disable-line no-shadow
    flushAddressSearch();
  }

  validation = ({ updateAddressFlag } = {}) => {
    const postalCodeValue = this.state.postalCodeRefValue || {};
    const nickNameValue = this.state.nickNameRefValue || {};
    const selectorStateValue = this.state.selectorStateRefValue || {};
    const selectorMunicipaltyValue = this.state.selectorMunicipaltyRefValue || {};
    const selectorColonyValue = this.state.selectorColonyRefValue || {};
    const otherColonyValue = this.state.otherColonyRefValue || {};
    const cityValue = this.state.cityRefValue || {};
    const buildingValue = this.state.buildingRefValue || {};
    const insideNumberValue = this.state.insideNumberRefValue || {};
    const outherNumberValue = this.state.outherNumberRefValue || {};
    const streetValue = this.state.streetRefValue || {};
    const betweenStreetValue = this.state.betweenStreetRefValue || {};
    const andStreetValue = this.state.andStreetRefValue || {};
    const privatePhoneValue = this.state.privatePhoneRefValue || {};
    const mobileValue = this.state.mobileRefValue || {};

    this.validationFlag = true;

    // ---------------field validation start--------------------
    const nickNameValid = nickNameValidation({ nickNameValue, userData: this.userData, currentUserData: this.currentUserData, currentUserMotherName: this.currentUserMotherName, deliveryAddressNickNames: this.state.deliveryAddressNickNames }); // Required
    const postalCodeValid = postalCodeValidation({ postalCodeValue }); // Required
    const addressStateValid = addressStateValidation({
      selectorStateValue,
    });
    const cityValid = cityValidation({ cityValue }); // Required
    const streetValid = streetValidation({ streetValue }); // required
    const outerNumberValid = outherNumberValidation({ outherNumberValue }); // required
    const mobileValid = mobileValidation({ mobileValue }); // required
    const privatePhoneValid = privatePhoneTotalValidation({ privatePhoneValue }); // required
    const municipaltyValid = municipaltyValidation({
      selectorMunicipaltyValue,
    }); // Required

    const colonyValid = colonyValidation({
      selectorColonyValue,
      otherColonyValue,
      showOtherColony: this.showOtherColony,
    }); // Required

    // Textfield without validation
    let interiorNumberValid = true;
    let buildingValid = true;
    let betweenStreetValid = true;
    let andStreetValid = true;

    interiorNumberValid = insideNumberValidation({ insideNumberValue }); // no required
    buildingValid = buildingValidation({ buildingValue }); // no required
    betweenStreetValid = betweenStreetValidation({ betweenStreetValue }); // no required
    andStreetValid = andStreetValidation({ andStreetValue }); // no required

    // ----------------end of valiadtion-------------------------
    const validForm = nickNameValid && postalCodeValid && addressStateValid && cityValid &&
      municipaltyValid && colonyValid && streetValid && outerNumberValid && privatePhoneValid &&
      interiorNumberValid && buildingValid && betweenStreetValid &&
      andStreetValid && mobileValid;

    if (validForm && updateAddressFlag && (Object.keys(this.userData)).length > 0) {
      const { state = {} } = this.props.location || {};
      
      const {eventId, isEventManagement } = state;

      //read the event management flag from route

      // * Data form sended for post request
      const addressDataPost = formDataValidation({ validationFlag: this.validationFlag });
      const { _fetchProfileEventsInfo } = this.props;
      _fetchProfileEventsInfo().then((res) => {
        if (res.status.status === 'success') { 
          if (this.locationQuery.addressId) {
            this.reqSaveAddressData(addressDataPost.addresses);
          } else {
            this.reqAddUserAddressDetail(addressDataPost.addresses);
          }
        } else if (res.status.status === 'failure') {
          browserHistory.push(applicationRoutes.createAccount);
        }
      });

      return;
    }

    createTagsForInvalidFormControls({
      controls: [
        selectorStateValue, andStreetValue, betweenStreetValue, buildingValue, cityValue,
        selectorColonyValue, insideNumberValue, mobileValue, selectorMunicipaltyValue, nickNameValue,
        otherColonyValue, outherNumberValue, postalCodeValue, privatePhoneValue, streetValue,
      ],
      tagCompositor: c => ({
        event: 'alerta',
        phase: 'Crear mesa de regalos',
        step: 'Direccion del evento',
        sub_phase: 'Agregar direccion',
        color: 'Rojo',
        mensaje: 'Campos incompletos',
        mensaje_servicio: _.get(c, 'errorControl.innerText', 'undefined error'),
        seccion: 'Mesa de Regalos',
        tipo: 'formulario',
      }),
    });
    // condition for focus validation
    focusValidation({ nickNameValid, postalCodeValid, addressStateValid, cityValid, municipaltyValid, colonyValid, otherColonyValue, streetValid, outerNumberValid, mobileValid, privatePhoneValid });
  }

  reqSaveAddressData = (dataFormPost) => {
    saveUserAddressDetail(dataFormPost).then((response) => {
      if (response.body.status.status === 'success') {
        browserHistory.push(this.currentEventUrl + '?addressUpdated=true');
        const { flushAddressSearch } = this.props; // eslint-disable-line no-shadow
        flushAddressSearch();
      } else if (response.body.status.status === 'failure') {
        this.state.warningRefValue.setMessage(response.body.status.errorMessage);
        this.state.warningRefValue.setType('error');
        this.scrollUp();
      }
    }).catch(() => {
      this.state.warningRefValue.setMessage('Ocurrió un error favor de intentar más tarde');
      this.state.warningRefValue.setType('error');
      this.scrollUp();
    });
  }

  reqFromDeliveryAddress = (dataFormPost, addressId) => {
    const { fromDeliveryAddress, eventId, celebrityName } = this.setCelebrityName();
    if (fromDeliveryAddress) {
      // ! Aditional data `particularPhoneCode` in not necessary for aditional address. Waiting update from back
      const particularPhoneCode = '000';
      const dataRequest = { ...dataFormPost, celebrityName, particularPhoneCode };
      const profileId = this.currentUserData.profileId;

      addEventDeliveryAddress(dataRequest, eventId, profileId, addressId).then((res) => {
        if (res.body.status.status === 'success') {
          this.props.getDeliveryAddressInfo(eventId);
          browserHistory.goBack();
          return;
        }
        if (res.body.status.status === 'failure') {
          getAddressFailedCreateTag({ errorMessage: res.body.status.status.errorMessage });
          this.state.warningRefValue.setType('warning');
          // browserHistory.goBack();
        }
      }).catch((e) => {
        this.state.warningRefValue.setMessage('Ocurrió un error, favor de intentar más tarde.');
        this.state.warningRefValue.setType('error');
        this.scrollUp();
      });
    }
  }

  mapBackendAddressToUIAddress = (address) => ({
    firstName: address.firstName || '',
    lastName: address.lastName || '',
    middleName: address.middleName || '',
    maternalName: address.secondLastName || '',
    phoneNumber: address.mobileNumber || address.phoneNumber || '',
    cellular: address.mobileNumber || '',
    businessPhoneNumber: address.businessPhoneNumber || '',
    city: address.cityDetail || '',
    delegationMunicipality: address.city || '',
    delegationMunicipalityId: address.cityId || '',
    postalCode: address.zipCode || '',
    address1: address.street || '',
    exteriorNumber: address.externalNumber || '',
    interiorNumber: address.internalNumber || '',
    address2: address.bStreet1 || '',
    address3: address.bStreet2 || '',
    building: address.building || '',
    nickName: address.nickname || '',
    country: address.country === 'MX' ? 'Mexico' : address.country,
    isEventAssociated: address.isEventAssociated || false,
    neighbourhood: address.settlement || '',
    neighbourhoodId: address.settlementId || '',
    addressId: address.id || '',
    state: address.state || '',
    stateId: address.stateId || '',
    otherColony: address.otherColony || '',
  });

  reqAddUserAddressDetail = (dataFormPost) => {
    const createEventObject = this.props.createEventObject || {};
    const { SelectTypeCelebration = {} } = createEventObject || {};
    const { selectedEventConfiguration = {} } = SelectTypeCelebration;
    const { fromDeliveryAddress } = this.fromEventDataCreated;

    addUserAddressDetail(dataFormPost).then((response) => {
      if (response.body.status.status === 'success') {
          const { state = {} } = this.props.location || {};
          const { isEventManagement } = state;
          if (isEventManagement) {
            const existingAddress = [...(this.props.eventManagementAddresses || [])];
            const uiAddress = this.mapBackendAddressToUIAddress(response.body.data);
            existingAddress.push(uiAddress);
            this.props.updateEventManagementAddresses(existingAddress);
            this.redirectToEventManagement();
            return true;
          }
        this.reqFromDeliveryAddress(dataFormPost, response.body.addressId);

        const { flushAddressSearch } = this.props;
        flushAddressSearch();

        if (!fromDeliveryAddress) {
          addAddressSuccessCreateTag({
            selectMesaType: this.props.createEventObject.SelectMesaType,
            eventConfigName: selectedEventConfiguration.name,
          });
          // eslint-disable-next-line no-unused-expressions
          sessionStorage.setItem("newAddedAddressId", response.body.data.id);
          this.currentEventUrl && browserHistory.push(this.currentEventUrl + '?address=true');
        }
      } else if (response.body.status.status === 'failure') {
        addAddressFailedCreateTag({ errorMessage: response.body.status.errorMessage });

        this.state.warningRefValue.setMessage(response.body.status.errorMessage);
        this.state.warningRefValue.setType('warning');
        this.scrollUp();
      }
    }).catch((e) => {
      this.state.warningRefValue.setMessage(e.body?.detail);
      this.state.warningRefValue.setType('error');
      this.scrollUp();
    });
  }

  disableSelectorsDepended = () => {
    if (!Array.isArray(this.setStateOption) && !Array.isArray(this.setStateOption)) {
      return false;
    }
    const dataForSelectors = (this.setStateOption.length <= 1 || this.setMunicipalityOption.length <= 1)
    && this.state.postalCodeRefValue.getValue() === '';

    return dataForSelectors;
  }

  getAddressDetail = () => {
    // ? flag validation selectors. depended state of postalCode field
    this.setState({
      ...this.state,
      emptyPostalCodeValid: this.disableSelectorsDepended(),
    });

    const { getAddressData,labels } = this.props;
    const object = {};
    object.action = 'EMA';
    this.lastPincode = this.state.postalCodeRefValue.getValue() || '';
    this.userData.postalCode = '';
    object.cp = this.lastPincode;

    if ((object.cp && object.cp.toString().length === 5)) {
      getAddressData(object).then((res) => {
        this.validation({ updateAddressFlag: false });
        if (res.status.status === 'success') {
          this.state.warningRefValue.setMessage('');
          this.setState({
            ...this.state,
            emptyPostalCodeValid: false,
          });
        }

        if (res.status.status === 'failure') {
          getAddressFailedCreateTag({ errorMessage: res.status.errorMessage });
          this.state.warningRefValue.setMessage(
            'No se encontró el código postal, ingresa uno diferente o verifica el que has proporcionado' || res.status.errorMessage);
          this.state.warningRefValue.setType('warning');
        }
      }).catch((e) => {
        this.validation({ updateAddressFlag: false });
        getAddressFailedCreateTag({ errorMessage: e?.errorMessage});
        
        if( e && e.errorMessage === 'zipcode.not.found') {
          this.state.warningRefValue.setMessage(commonUtil.getLabel(labels.createEventStep3, e?.errorMessage) || e?.errorMessage);
        } else {
          this.state.warningRefValue.setMessage(e?.errorMessage);
        }
        this.state.warningRefValue.setType('warning');
        this.scrollUp();
      });
    }
  }

  handleAllowOnlyDigit = (e) => {
    const ctl = e.target.id;
    const limitLength = e.target.maxLength;
    const thisObj = document.querySelector('#' + ctl);
    const keyCode = e.keyCode;
    // backspace, delete, left arrow and right arrow
    if (keyCode === 46 || keyCode === 8 || keyCode === 9 || keyCode === 37 || keyCode === 39) {
      return true;
    }
    if ((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105)) {
      // numbers and numeric keypad
      if (thisObj.value.length > limitLength) {
        e.preventDefault();
        e.stopPropagation();
      }
    } else {
      e.preventDefault();
      e.stopPropagation();
    }
    return true;
  }

  scrollUp = () => window.scrollTo(0, 0);

  showOtherColonyOption = (e) => {
    if (e.value === 'Otra colonia') {
      this.setState({
        ...this.state,
        showOtherColony: true,
      });
    } else {
      this.setState({
        ...this.state,
        showOtherColony: false,
      });
    }
  }

  handleAllowOnlyAlpha = (e) => {
    const _char = String.fromCharCode(e.charCode);
    if (!(/^[a-zA-z0-9ñÑ\s]+$/.test(_char))) {
      e.preventDefault();
    }
  }

  onChangeEventName = () => {
    const nickName = this.state.nickNameRefValue;
    nickName.setValue(nickName.getValue().replace(/[^a-zA-z0-9ñÑ\s]/gi, ''));
  }

  configRefsElement = ({ addressState, municipalty, colony }) => {
    this.setState({
      ...this.state,
      selectorStateRefValue: addressState,
      selectorMunicipaltyRefValue: municipalty,
      selectorColonyRefValue: colony,
    });
  }

  handleSelectorRefValue = (typeSelector, selectorRefValue, event) => {
    const typeSelectorForm = {
      municipalty: () => this.setState({ ...this.state, selectorMunicipaltyRefValue: selectorRefValue }),
      stateOfCountry: () => this.setState({ ...this.state, selectorStateRefValue: selectorRefValue }),
      colony: () => this.setState({ ...this.state, selectorColonyRefValue: selectorRefValue }, () => {
        this.showOtherColonyOption(event);
      }),
    };

    return typeSelectorForm[typeSelector]();
  }

  formatPrivatePhoneNumber = () => {
    const codeData = {};
    const { phoneNumber } = this.userData || {};

    if (phoneNumber) {
      const index = phoneNumber.indexOf('-');
      codeData.particularPhoneCode = phoneNumber.substr(0, index);
      codeData.phoneNumber = phoneNumber.substr(index + 1);
    }

    return codeData;
  }

  dataForEditionMode = ({ giftRegistryAddress }) => {
    if (giftRegistryAddress && giftRegistryAddress.data && giftRegistryAddress.data.addresses) {
      const id = this.locationQuery.addressId || '';
      giftRegistryAddress.data.addresses.map((data) => {
        if ((data.nickName !== 'undefined') && (id !== 'undefined') && data.nickName === id) {
          this.userData = data;
          return this.userData;
        }
        return null;
      });
    }
  }

  warningMessageFailureService = ({ giftRegistryNewAddress }) => {
    if (this.state.warningRefValue) {
      this.state.warningRefValue.setMessage('');
      this.state.warningRefValue.setType('');
    }
    // * when service /currentUser/getAddresses fail
    if (giftRegistryNewAddress && giftRegistryNewAddress.status && giftRegistryNewAddress.status.status === 'failure') {
      this.showOtherColony = false;
      const errorMsg = (giftRegistryNewAddress.status.errorMessage || giftRegistryNewAddress.errorMessage);
      if (this.state.warningRefValue) {
        this.state.warningRefValue.setMessage(errorMsg);
        this.state.warningRefValue.setType('');
      }
    }
  }

  render() {
    const { labels, giftRegistryNewAddress, giftRegistryAddress, stateList } = this.props;
    if (!(!!labels || !!giftRegistryNewAddress)) return null;

    this.editAddress = this.locationQuery.addressId;

    this.warningMessageFailureService({ giftRegistryNewAddress });
    this.dataForEditionMode({ giftRegistryAddress });

    const { colonyOptions = [], colonyName, otherColonyValue } = colonySetOptions({
      giftRegistryNewAddress,
      userData: {},
    });

    const { stateOptions = [], selectedStateValue } = stateSetOptions({
      stateList,
      giftRegistryNewAddress,
      userData: {},
    });


    const { municipaltyOptions = [], municipaltyName } = municipalitySetOptions({
      giftRegistryNewAddress,
      userData: {},
    });

    this.setMunicipalityOption = [...municipaltyOptions];
    this.setStateOption = [...stateOptions];
    this.setColonyOption = [...colonyOptions];
    this.showOtherColony = this.state.showOtherColony || otherColonyValue;
    return (
      <React.Fragment>
        <ApplyCSS pageName={pageName} />
        <div className="mainContainerFormRegistry">
          <div className={channel === 'web' ? 'container' : ' '}>
            <div>
             {
              channel === 'web' && <p className='newAddressCreationText'>{commonUtil.getLabel(labels.createEventStep3, 'createEventStep3.thirdStepHeading.label')}</p>
             } 
              <div
                id="giftRegistry"
                className="giftRegistryFormContainer"
                style={{ background: 'white' }}
              >
                <HeaderFormRegister
                  labels={labels}
                  user={this.user}
                  setRefWarning={this.setRefWarning}
                />
                <AddAddressForm
                  codeData={this.formatPrivatePhoneNumber()}
                  colonyOptions={this.state.emptyPostalCodeValid ? [] : colonyOptions}
                  municipaltyOptions={this.state.emptyPostalCodeValid ? [] : municipaltyOptions}
                  optionsSelector={this.state.emptyPostalCodeValid ? [] : stateOptions}
                  addressSearchLoading={this.addressSearchLoading}
                  lastPincode={this.lastPincode}
                  userData={this.userData}
                  showOtherColony={this.showOtherColony}
                  setRef={this.setRef}
                  handleAllowOnlyDigit={this.handleAllowOnlyDigit}
                  handleAllowOnlyAlpha={this.handleAllowOnlyAlpha}
                  handleSelectorRefValue={this.handleSelectorRefValue}
                  otherColonyValue={otherColonyValue}
                  onChangeEventName={this.onChangeEventName}
                  getAddressDetail={this.getAddressDetail}
                  emptyPostalCode={this.state.emptyPostalCodeValid}
                  municipaltyName={municipaltyName}
                  selectedState={selectedStateValue}
                  colonyId={colonyName}
                  textIdElements={textIdElements}
                  configRefsElement={this.configRefsElement}
                  onPasteFuncOnlyAlpha={() => {}}
                  outherNumberVal={this.state.outherNumberRefValue}
                  isWeb = {channel === 'web' ? true : false}
                  deliveryAddressNickNames={this.state.deliveryAddressNickNames}
                />
                <BottomFormRegister
                  redirectToPrevPage={this.redirectToPrevPage}
                  validation={() => this.validation({ updateAddressFlag: true })}
                />
              </div>

            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const matchDispatchToProps = dispatch => bindActionCreators({ getDeliveryAddressInfo ,updateDeliveryAddress, updateEventManagementAddresses}, dispatch);

export default connect(null, matchDispatchToProps)(GiftRegistryNewAddress);

